import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enAuth from './en/auth.json';
import enAssessment from './en/assessment.json';
import enComplianceRequirements from './en/complianceRequirements.json';
import enServiceProviderUsers from './en/serviceProviderUsers.json';
import enInternalUsers from './en/internalUsers.json';
import enProfile from './en/profile.json';
import enComplianceReviewDashboard from './en/complianceReviewDashboard.json';
import esCommon from './es/common.json';
import esNavigation from './es/navigation.json';
import esAuth from './es/auth.json';
import esAssessment from './es/assessment.json';
import esComplianceRequirements from './es/complianceRequirements.json';
import esServiceProviderUsers from './es/serviceProviderUsers.json';
import esInternalUsers from './es/internalUsers.json';
import esProfile from './es/profile.json';
import esComplianceReviewDashboard from './es/complianceReviewDashboard.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    assessment: enAssessment,
    complianceRequirements: enComplianceRequirements,
    serviceProviderUsers: enServiceProviderUsers,
    internalUsers: enInternalUsers,
    profile: enProfile,
    complianceReviewDashboard: enComplianceReviewDashboard,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    auth: esAuth,
    assessment: esAssessment,
    complianceRequirements: esComplianceRequirements,
    serviceProviderUsers: esServiceProviderUsers,
    internalUsers: esInternalUsers,
    profile: esProfile,
    complianceReviewDashboard: esComplianceReviewDashboard,
  },
} as const;

i18n
  .use(initReactI18next)
  .init({
    lng: 'en', // Default language
    fallbackLng: 'en',
    defaultNS,
    ns: ['common', 'navigation', 'auth', 'assessment', 'complianceRequirements', 'serviceProviderUsers', 'internalUsers', 'profile', 'complianceReviewDashboard'],
    
    resources,
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    
    // Language detection (you can add more sophisticated detection later)
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Development options
    debug: import.meta.env.DEV,
    
    // Keyseparator and nsSeparator
    keySeparator: '.',
    nsSeparator: ':',
    
    // React options
    react: {
      useSuspense: false, // Set to false to avoid suspense issues during initial load
    },
  });

export default i18n;